module.exports = __webpack_public_path__ + "img/changfang2.c5dfad54.png";